import { render } from "./About.vue?vue&type=template&id=7c725e07&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=7c725e07&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Christian\\Documents\\Progetti\\ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c725e07"]])

export default __exports__